/**
 * Format a price (0-1 range) to cents display, preserving sub-cent precision.
 * - 0.72 → "72"
 * - 0.725 → "72.5"
 * - 0.6552 → "65.5" (1 decimal)
 * Used across all market sources (Polymarket, Kalshi, Predict.fun).
 */
export function fmtCents(price: number, decimalPrecision?: number): string {
  // Guard non-finite (NaN, ±Infinity) up front. Without this, callers that
  // pass `Number(event.price)` where event.price is undefined/null/garbage
  // render "NaN" (or "0¢" if the backend ever emits `null`, which would
  // look like a free trade in activity rows). One central guard beats
  // sprinkling isFinite checks across 9 row components.
  if (!Number.isFinite(price)) return '—';
  const cents = price * 100;
  if (decimalPrecision != null && decimalPrecision > 0) return cents.toFixed(decimalPrecision);
  const rounded = Math.round(cents);
  return Math.abs(cents - rounded) > 0.05 ? cents.toFixed(1) : rounded.toString();
}
